export const formatPhone = (p) => {
  if (!p) return "";
  const d = p.replace(/\D/g, "");
  const n = d.length === 11 && d.startsWith("1") ? d.slice(1) : d;
  if (n.length === 10) return `+1 (${n.slice(0, 3)}) ${n.slice(3, 6)}-${n.slice(6)}`;
  return p;
};

export const telHref = (p) => {
  const d = (p || "").replace(/\D/g, "");
  return `tel:+${d}`;
};
